$(function () {
    require('backbone.radio');
    require('../vendor/modernizr');
    require('../scss/bootstrap.scss');
    require('../vendor/bootstrap-grid-flexbox/bootstrap-grid-flexbox.scss');

    var LocationEntities = require('./entities/location');
    var UIUtils = require('./utils/ui');
    var LocationsList = require('./common/locations-list');
    var FarmBranding = require('./common/farm-branding.js');

    var App = Marionette.Application.extend({
        _rootView: null,
        _appChannel: null,
        _settings: null,
        _router: null,
        initialize: function (options) {

            var self = this;
            self.options = _.defaults(
                options || {}, {}
            );

            self._appChannel = Backbone.Radio.channel('footer:' + self.options.instanceId);
            self._globalChannel = Backbone.Radio.channel('global');

            self._locations = new LocationEntities.PageableLocationCollection(
                self.options.locations
            );
        },
        _renderBranding: function () {
          this._branding = new FarmBranding({
            style: 'full'
          });
          this.options.layout.getRegion('brandingRegion').show(this._branding);
        },
        _renderLocationList: function() {
          var self = this;
          this.locationsList = new LocationsList({
            collection: this._locations,
            resizeHeightToScreenSize: false,
            actionButton: false,
            clickableLocationInfo: true
          });

          this.locationsList.on('info:clicked', function (model) {
            window.stop();
            $(location).prop('href', model.get('home_page_url'));
          });

          this.options.layout.getRegion('locationListRegion').show(this.locationsList);
        },
        onStart: function () {
            var self = this;
            this._renderLocationList();
            this._renderBranding();
        }
    });

    $('.farmacy-footer').each(function(index) {
        renderFooter(this);
    });

    function renderFooter(el) {
      var layout = new (require('./footer-app/root'))({
          locations: $(el).data('locations')
      });
      var app = new App({
          layout: layout,
          instanceId: $(el).data('instanceid'),
          locations: $(el).data('locations'),
      });

      var region = new Marionette.Region({
          el: el
      });

      layout.on('render', function () {
          app.start();
      });

      region.show(layout);
    }
});



/** WEBPACK FOOTER **
 ** ./assets/js/public-footer-app.js
 **/